import styled, { css } from 'styled-components';
import { zIndex } from 'styles';
import Tokens from '@nokia-csf-uxr/freeform-design-tokens';
import { BORDER_BOX } from 'common';

const MAX_WIDTH = '30rem';

export default {
  TooltipTextContainer: styled.div`
    ${BORDER_BOX}
    max-width: ${({ isText }) => (isText ? MAX_WIDTH : 'none')};
    word-break: ${({ isText }) => (isText ? 'break-word' : 'normal')}; // when there is one huge text string
    white-space: ${({ isText }) => (isText ? 'pre-line' : 'normal')};
    padding: ${Tokens.SPACING.SPACING_8};
    border-radius: ${Tokens.RADIUS.RADIUS_2};
    background: ${({ isText, $theme }) => (isText ? $theme.container : $theme.richContainer)};
    color: ${({ isText, $theme }) => (isText ? $theme.content : $theme.richContent)};
    ${css(Tokens.TYPOGRAPHY.MICRO)}
    ${({ $rtl }) => $rtl && css`direction: rtl;`}
  `,
  ContentContainer: styled.div`
    z-index: ${zIndex.TOOLTIP};
  `
};
